import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

// Bootstrap CSS
// @ts-ignore
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
// Bootstrap Icons
// @ts-ignore
import "bootstrap-icons/font/bootstrap-icons.css" ;
// Custom Stylesheet Parent
// Ignore TS checking for this SCSS side-effect import (no type declarations)
// @ts-ignore
import './index.scss';
// React-DatePicker CSS
// @ts-ignore
import "react-datepicker/dist/react-datepicker.css" ;

// gridstack's CSS import can cause TypeScript to complain about missing type declarations.
// Ignore TS checking for this side-effect import.
// @ts-ignore
import "gridstack/dist/gridstack.min.css";


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
